<template>
  <el-dialog v-if="reg" width="40rem" title="就诊号详细" :visible="visible" :close-on-click-modal="false" @close="close" @open="open" top="10vh" modal-append-to-body>
    <el-descriptions title="基本信息" :column="3" style="margin-left: 3rem">
      <el-descriptions-item label="编号">{{ reg.opNo }}</el-descriptions-item>
      <el-descriptions-item label="号别">{{ reg.regType | dictText("RegType") }}</el-descriptions-item>
      <el-descriptions-item label="加号">{{ reg.ifDoctorAdd ? "是" : "否" }}</el-descriptions-item>
      <el-descriptions-item label="科室">{{ reg.deptCode | dictText("Dept") }}</el-descriptions-item>
      <el-descriptions-item label="医师">{{ reg.doctorName }}</el-descriptions-item>
      <el-descriptions-item label="日期">{{ reg.date }}</el-descriptions-item>
      <el-descriptions-item label="午别">{{ reg.periodType }}</el-descriptions-item>
      <el-descriptions-item label="序号">{{ reg.seqNo }}</el-descriptions-item>
      <el-descriptions-item label="候诊">{{ reg.periodStart }}~{{ reg.periodEnd }}</el-descriptions-item>
      <el-descriptions-item label="急诊">{{ reg.ifEmergency ? "是" : "否" }}</el-descriptions-item>
      <el-descriptions-item label="挂号员">{{ reg.registrarName }}</el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-tag v-if="reg.state == '预约'" type="primary" size="small" effect="plain">{{ reg.state }}</el-tag>
        <el-tag v-else-if="reg.state == '报到'" type="success" size="small" effect="plain">{{ reg.state }}</el-tag>
        <el-tag v-else-if="reg.state == '取号'" type="warning" size="small" effect="plain">{{ reg.state }}</el-tag>
        <el-tag v-else size="small" type="danger" effect="plain">{{ reg.state }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="患者信息" :column="3" style="margin-left: 3rem">
      <el-descriptions-item label="姓名">{{ reg.patientName }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ reg.patientGender | dictText("Gender") }}</el-descriptions-item>
      <el-descriptions-item label="年龄">{{ reg.patientAge }}</el-descriptions-item>
      <el-descriptions-item label="证件">{{ reg.cardType || reg.appCardType | dictText("IdType") }}</el-descriptions-item>
      <el-descriptions-item label="号码">{{ (reg.cardNo || reg.appCardNo) | mask }}</el-descriptions-item>
      <el-descriptions-item label="类型">
        <el-tag v-if="Enum.OpType.医保工伤 == reg.opType" size="small" effect="plain" type="danger">{{ reg.opType }} </el-tag>
        <el-tag v-else-if="Enum.OpType.医保 == reg.opType" size="small" effect="plain" type="warning">{{ reg.opType }} </el-tag>
        <el-tag v-else size="small" effect="plain" type="success">{{ reg.opType }} </el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="费用信息" :column="3" style="margin-left: 3rem" contentClassName="right">
      <el-descriptions-item label="费用合计">{{ payment.feeAmount | fmtFloat(2) }}</el-descriptions-item>
      <el-descriptions-item label="基金支付" v-if="payment.id">{{ payment.feeFund | fmtFloat(2) }}</el-descriptions-item>
      <el-descriptions-item label="个人账户" v-if="payment.id">{{ payment.feeAccount | fmtFloat(2) }}</el-descriptions-item>
      <el-descriptions-item label="个人支付" v-if="payment.id" contentStyle="color:red">{{ (payment.feeCash) | fmtFloat(2) }}</el-descriptions-item>
      <el-descriptions-item label="支付方式" v-if="payment.id" contentStyle="color:orange">{{ payment.payWay | dictText("PayWay") }}</el-descriptions-item>
      <el-descriptions-item label="支付状态">
        <el-tag v-if="payment.state == '已执行'" type="success" size="small" effect="plain">已支付</el-tag>
        <el-tag v-else size="small" type="danger" effect="plain">未支付</el-tag>
      </el-descriptions-item>
      <el-descriptions-item v-if="payment.id" label="收费员">{{ payment.operatorUserName }}</el-descriptions-item>
      <!-- <el-descriptions-item label="打印">{{ payment.printed ? "已打印" : "未打印"}}</el-descriptions-item> -->
      <el-descriptions-item v-if="payment.id" label="发票号">{{ payment.invoiceNo }}</el-descriptions-item>
    </el-descriptions>
    <el-popover placement="top-start" trigger="hover">
      <h3 style="text-align: center">时间点</h3>
      <el-timeline>
        <el-timeline-item :timestamp="reg.appointmentDate" type="success">预约</el-timeline-item>
        <el-timeline-item :timestamp="reg.takingDate" :type="!!reg.takingDate ? 'success' : ''">取号</el-timeline-item>
        <el-timeline-item :timestamp="reg.signInDate" :type="!!reg.signInDate ? 'success' : ''">排队</el-timeline-item>
        <el-timeline-item :timestamp="reg.treatDate" :type="!!reg.treatDate ? 'success' : ''">就诊</el-timeline-item>
      </el-timeline>
      <el-button type="default" icon="el-icon-date" circle size="mini" slot="reference"></el-button>
    </el-popover>
    <template slot="footer">
      <small v-if="!payment.printed && invoiceNo && !reg.ifDoctorAdd">当前发票号：{{ invoiceNo }}</small>
      <el-button v-if="!payment.printed && invoiceNo && !reg.ifDoctorAdd" type="info" class="left-pad" @click="printInvoice" icon="el-icon-printer" size="small">发票</el-button>
      <el-button v-if="!reg.ifDoctorAdd" type="info" @click="printReceipt" icon="el-icon-printer" size="small">凭证</el-button>
      <el-button v-if="!readOnly && reg.state == '预约' && reg.paymentState == '收款'" type="primary" @click="take" icon="el-icon-thumb" size="small">取号</el-button>
      <!-- 医生通过诊间加号的患者，【退号】按钮不可点击 20220804 -->
      <!-- payWay为applet小程序时，不能退号 20221207 -->
      <el-button
        v-if="refundreadOnly"
        type="danger"
        @click="refund"
        icon="el-icon-delete"
        size="small">
        退号
      </el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
    <refund :visible.sync="meta.showRefund" :pay-entity="payment" @ok="refunded"></refund>
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";
import printMixin from '../_com/printMixin';

export default {
  mixins: [printMixin],
  components: {
    refund: () => import("@/components/fee/refund"),
  },
  props: {
    visible: { type: Boolean, default: false },
    reg: Object,
    readOnly: Boolean,
  },
  data () {
    return {
      meta: {
        showRefund: false,
      },
      payment: {},
      invoiceNo: null,
    };
  },
  computed: {
    ...mapGetters(["user", "permission", "dict", "Enum"]),
    refundreadOnly() {
      return !this.readOnly && this.permission.registration_registry_delete
      && this.reg.state != '就诊' && this.reg.state != '完诊' && !this.reg.ifDoctorAdd
      && this.payment.payWay !== 'applet' && this.payment.id
    }
  },
  methods: {
    close () {
      this.$emit("update:visible", false);
    },
    open () {
      if (this?.reg?.paymentId) {
        api
          .getPayment(this.reg.paymentId)
          .then((res) => {
            this.payment = res || {};
            if (!this.payment.isPrinted) {
              return api.invoiceCurrent();
            } else {
              this.invoiceNo = null;
            }
          })
          .then((res) => {
            this.invoiceNo = res;
          });
      } else {
        this.payment = {
          feeAmount: this.reg.price,
          state: "未支付",
        };
      }
    },
    printReceipt () {
      this.printReceiptFn(this.reg, this.payment); // 来源 printMixin.js
    },
    async setInvoiceData () {
      let insuranceDivInfo = JSON.parse(this.payment.insuranceDivisionInfo);
      return {
        invoiceCode: '',
        invoiceNo: this.invoiceNo,
        eInvoiceCode: '',
        eInvoiceNo: '',
        payerInsCode: '',
        validateCode: '',
        payer: '',
        issueDate: await this.$utils.getServerTime(),
        detail: [
          {
            name: '检查费用',
            unit: '',
            amount: '50.00',
            memo: '无自付'
          },
          {
            name: '电脑多导联心电图',
            unit: '1/',
            amount: '20.00',
            memo: '无自付'
          },
          {
            name: '卫生材料费',
            unit: '1/',
            amount: '200.00',
            memo: '无自付'
          },
        ],
        amountInWords: this.$utils.chaineseMoney(this.payment.amount),
        amountInFigures: this.$utils.fmtFloat(this.payment.amount.toString(), 2).toString(),
        serialNo: this.payment.paymentSerialNo ? this.payment.paymentSerialNo : '',
        opNo: this.reg.opNo,
        opDate: this.reg.treatDate,
        hospitalType: '未知',
        insType: '',
        insNo: '',
        gender: this.$utils.dictText(this.reg.patientGender, 'Gender'),
        NhospFundPay: this.$utils.fmtFloat(this.payment.accountPayments, 2).toString(),
        NotherPay: this.$utils.fmtFloat('0', 2).toString(),
        NindvActt: this.$utils.fmtFloat(this.payment.payment, 2).toString(),
        NindvCash: this.$utils.fmtFloat(0, 2).toString(),
        NindvPay: this.$utils.fmtFloat(0, 2).toString(),
        NselfPay: this.$utils.fmtFloat(0, 2).toString(),
        NindvPay1: this.$utils.fmtFloat(0, 2).toString(),
        NopPay: this.$utils.fmtFloat(0, 2).toString(),
        NinsIn: this.$utils.fmtFloat(insuranceDivInfo.in, 2).toString(),
        NopYearPay: this.$utils.fmtFloat(0, 2).toString(),
        NpayStart: this.$utils.fmtFloat(0, 2).toString(),
        NretirePay: this.$utils.fmtFloat(0, 2).toString(),
        NinsYearIn: this.$utils.fmtFloat(0, 2).toString(),
        NindvBal: this.$utils.fmtFloat(0, 2).toString(),
        NoverAmount: this.$utils.fmtFloat(0, 2).toString(),
        NarmyPay: this.$utils.fmtFloat(0, 2).toString(),
        NindvPay2: this.$utils.fmtFloat(0, 2).toString(),
        NorgPay: this.$utils.fmtFloat(0, 2).toString(),
        trxnNo: this.payment.insuranceSerialNo ? this.payment.insuranceSerialNo : '',
        reviewer: '',
        payee: this.payment.operatorUserName
      };
    },
    printInvoice () {
      this.setInvoiceData().then(r => {
        return this.$utils.printRpt('OpInvoice', r);
      }).then(r => {
        // this.$message({
        //   type: 'success',
        //   message: '打印成功！'
        // });
      }).catch(e => {
        this.$message({
          type: 'error',
          message: e
        })
      })
    },
    take () {
      api.takeRegNo(this.reg.id).then((res) => {
        this.reg.state = res.state;
        this.reg.doctorId = res.doctorId;
        this.reg.doctorName = res.doctorName;
      });
    },
    refund () {
      if (this.reg.state == this.Enum.RegState.就诊 || this.reg.state == this.Enum.RegState.完诊) {
        this.$message.error("就诊号已就诊，禁止退款！");
        return
      }

      if (!this.reg.paymentState || this.reg.paymentState == this.Enum.PaymentState.未支付) {
        this.$confirm("就诊号尚未收费，确定要直接退号吗？", "退号确认").then((res) => {
          this.refunded();
        }).catch(err => { });
      } else {
        this.$nextTick(() => {
          this.meta.showRefund = true;
        });
      }
    },
    refunded () {
      // 退号
      api.delAppointment(this.reg.id).then((res) => {
        this.$message.success("已取消锁号！");
        this.$emit("refunded")
        this.$emit("update:visible", false);
      }).catch(err => {
        this.$message.error(err.message || err);
      });
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}
</style>
